import React from 'react';
import './Dashboard.css';

function Dashboard({ stats, loading }) {
  if (loading) {
    return <div className="loading">Loading dashboard stats...</div>;
  }

  if (!stats) {
    return <div className="error">Failed to load stats</div>;
  }

  return (
    <div className="dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <div className="stat-label">Total Revenue</div>
            <div className="stat-value">KES {stats.transactions.revenue.toLocaleString('en-KE', { minimumFractionDigits: 2 })}</div>
            <div className="stat-change positive">
              +KES {stats.transactions.revenue_24h.toFixed(2)} today
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <div className="stat-label">Total Transactions</div>
            <div className="stat-value">{stats.transactions.total}</div>
            <div className="stat-change positive">
              +{stats.transactions.last_24h} in last 24h
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <div className="stat-label">Successful Payments</div>
            <div className="stat-value">{stats.transactions.successful}</div>
            <div className="stat-change">
              {stats.transactions.pending} pending
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <div className="stat-label">Active Subscriptions</div>
            <div className="stat-value">{stats.subscriptions.active}</div>
            <div className="stat-change">
              {stats.subscriptions.total} total subscriptions
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-content">
            <div className="stat-label">Subscription Revenue</div>
            <div className="stat-value">KES {stats.subscriptions.revenue.toLocaleString('en-KE', { minimumFractionDigits: 2 })}</div>
            <div className="stat-change">
              From active subscriptions
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⏰</div>
          <div className="stat-content">
            <div className="stat-label">Expired Subscriptions</div>
            <div className="stat-value">{stats.subscriptions.expired}</div>
            <div className="stat-change">
              Need renewal
            </div>
          </div>
        </div>
      </div>

      <div className="quick-stats">
        <div className="quick-stat-card">
          <h3>Success Rate</h3>
          <div className="percentage">
            {((stats.transactions.successful / stats.transactions.total) * 100).toFixed(1)}%
          </div>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{width: `${(stats.transactions.successful / stats.transactions.total) * 100}%`}}
            ></div>
          </div>
        </div>

        <div className="quick-stat-card">
          <h3>Subscription Active Rate</h3>
          <div className="percentage">
            {stats.subscriptions.total > 0 
              ? ((stats.subscriptions.active / stats.subscriptions.total) * 100).toFixed(1)
              : 0}%
          </div>
          <div className="progress-bar">
            <div 
              className="progress-fill success" 
              style={{width: `${stats.subscriptions.total > 0 ? (stats.subscriptions.active / stats.subscriptions.total) * 100 : 0}%`}}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
